import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { getApiOrigin } from '../../services/config';


const Login = ({ onLoginSuccess }) => {
  const { t } = useTranslation();
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState(null);

  useEffect(() => {
    const getCsrfToken = async () => {
      try {
        await axios.get('/api/csrf/', {
          withCredentials: true
        });
      } catch (error) {
        console.error('Error fetching CSRF token:', error);
      }
    };
    getCsrfToken();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const response = await axios.post(
        '/api/signin/',
        credentials,
        {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }
      );

      localStorage.setItem('token', response.data.token);
      axios.defaults.headers.common['Authorization'] = `Token ${response.data.token}`;
      onLoginSuccess();
    } catch (error) {
      setError(error.response?.data?.error || t('login_error'));
      console.error('Login error:', error);
    }
  };

  const handleOAuthLoginClick = async () => {
    try {
      const apiOrigin = getApiOrigin();
      window.location.assign(`${apiOrigin}/api/organization/oauth/login/?hostname=${window.location.hostname}`);
    } catch (error) {
      console.error('OAuth login error:', error);
      setError('Could not initiate OAuth login process.');
    }
  };

  return (
    <div className="center-screen">
      <div className="card" style={{ width: '320px' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '16px' }}>{t('login_title')}</h2>

        {error && (
          <div
            className="card"
            style={{
              background: 'color-mix(in oklab, var(--color-danger) 12%, var(--surface))',
              color: 'var(--text)',
              border: '1px solid',
              borderColor: 'color-mix(in oklab, var(--color-danger) 35%, var(--border))',
              padding: '10px',
              borderRadius: '5px',
              marginBottom: '15px',
              fontSize: '14px',
              textAlign: 'center'
            }}
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="label">{t('username_label')}</label>
            <input
              type="text"
              name="username"
              value={credentials.username}
              onChange={handleChange}
              className="input"
              style={{ direction: 'ltr', textAlign: 'left' }}
            />
          </div>
          <div className="form-group">
            <label className="label">{t('password_label')}</label>
            <input
              type="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              className="input"
              style={{ direction: 'ltr', textAlign: 'left' }}
            />
          </div>
          <button type="submit" className="btn btn-primary btn-full">
            {t('login_button')}
          </button>
        </form>


        <button
          type="button"
          onClick={handleOAuthLoginClick}
          className="btn btn-secondary btn-full"
        >
          {t('login_oauth')}
        </button>
      </div>
    </div>
  );
};

export default Login;
